import { render, staticRenderFns } from "./AlertRelatedFiles.vue?vue&type=template&id=27f8b9ce&scoped=true&"
import script from "./AlertRelatedFiles.vue?vue&type=script&lang=js&"
export * from "./AlertRelatedFiles.vue?vue&type=script&lang=js&"
import style0 from "./AlertRelatedFiles.vue?vue&type=style&index=0&id=27f8b9ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f8b9ce",
  null
  
)

export default component.exports